import {
  combine,
  createEffect,
  createEvent,
  createStore,
  sample,
} from 'effector'
import { persist } from 'effector-storage/local'
import { runtime } from '~/app/environment'
import { features } from '~/core/flags'
import { model as config } from '~/shared/config'
import { noop as noopEvent } from '~/shared/effector'
import { noop } from '~/shared/helpers'

export const init = createEvent()

const eraValue = runtime.app.organizationId ?? null

// "era" value
const $organizationIdEra = createStore<number | null>(
  Number.isFinite(eraValue) ? eraValue : null
)
// "saved firebase" and "new firebase" value
const $organizationIdFirebase = createStore<number | null>(null).on(
  config.$config,
  (state, c) =>
    Number.isFinite(c.tria_organizationId) ? c.tria_organizationId : state
)

// Latest organisation Id
export const $organizationId = combine(
  $organizationIdEra,
  $organizationIdFirebase,
  (idEra, idFirebase) => idFirebase ?? idEra
)

const updateRuntimeValueFx = createEffect<number | undefined, void>((id) => {
  runtime.app.organizationId = id
})

/*
 * Update runtime value with "latest firebase" value
 */
sample({
  clock: $organizationId,
  fn: (newId) => newId ?? undefined,
  target: updateRuntimeValueFx,
})

/*
 * Save latest firebase value to local store
 */
// we do not use scopes for now, so, ignore this rule
// eslint-disable-next-line effector/require-pickup-in-persist
persist({
  store: $organizationIdFirebase,
  key: 'tria__organization-id',
  fail: noopEvent,
})

/*
 * Refetch features if new value come
 */
sample({
  clock: $organizationId.updates,
  fn: noop,
  target: features.getFx,
})
